<template>
  <div>
    <div id="sidebar-button" @click="show=!show"> <i class="fa" :class="show ? 'fa-close' : 'fa-bars'"/></div>
    <div id="sidebar" :class="show? '': 'hide-sidebar'">
      <div  id="sidebar-content">
        <nav class="panel">
          <p class="panel-heading">
            Main navigation
          </p>
          <span @click="show=false">
            <router-link :to="{name: 'dashboard'}" class="panel-block">
              <span class="panel-icon"><i class="fa fa-dashboard"/></span>
              Dashboard
            </router-link>
            <router-link :to="{name: 'shipment-list'}" class="panel-block">
              <span class="panel-icon"><i class="fa fa-ship"/></span>
              Shipments
            </router-link>
            <router-link :to="{name: 'tracking-request-list'}" class="panel-block">
              <span class="panel-icon"><i class="fa fa-archive"/></span>
              Tracking requests
            </router-link>
            <router-link :to="{name: 'tracking-request-add'}" class="panel-block">
              <span class="panel-icon"><i class="fa fa-file"/></span>
              New tracking request
            </router-link>
          </span>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sidebar',
  data () {
    return {
      show: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Sidebar.vue